import ukraineRegionsData from './ukraine-regions.json'

export const ukraineRegionOptions = ukraineRegionsData
